<template>
  <div class="task-progress-container">
    <!-- <div class="task-progress-title text-center">{{ taskInfo?.taskName }}</div> -->
    <div class="task-progress flex-center">
      <div class="task-progress-item pointer" :class="{ active: taskInfo?.tkState, current: props.current == 1 }"
        @click="linkTo(0)">
        <loading-outlined class="icon-loading" v-if="stepLoadingStates[0]" />
        <check-circle-filled class="icon-check-circle" v-else-if="taskInfo?.tkState" />
        <span class="icon-uncheck-circle" v-else></span>
        题卡设置
      </div>
      <span class="task-progress-arrow">→</span>
      <div class="task-progress-item pointer" :class="{ active: taskInfo?.yjState, current: props.current == 2 }"
        @click="linkTo(1)">
        <loading-outlined class="icon-loading" v-if="stepLoadingStates[1]" />
        <check-circle-filled class="icon-check-circle" v-else-if="taskInfo?.yjState" />
        <span class="icon-uncheck-circle" v-else></span>
        阅卷设置
      </div>
      <span class="task-progress-arrow">→</span>
      <div class="task-progress-item pointer" :class="{ active: taskInfo?.mbzzState, current: props.current == 3 }"
        @click="linkTo(2)">
        <loading-outlined class="icon-loading" v-if="stepLoadingStates[2]" />
        <check-circle-filled class="icon-check-circle" v-else-if="taskInfo?.mbzzState" />
        <span class="icon-uncheck-circle" v-else></span>
        模板制作
      </div>
      <span class="task-progress-arrow">→</span>
      <div class="task-progress-item pointer" :class="{ active: taskInfo?.djsmState, current: props.current == 4 }"
        @click="linkTo(3)">
        <loading-outlined class="icon-loading" v-if="stepLoadingStates[3]" />
        <check-circle-filled class="icon-check-circle" v-else-if="taskInfo?.djsmState" />
        <span class="icon-uncheck-circle" v-else></span>
        答卷扫描
      </div>
      <span class="task-progress-arrow">→</span>
      <div class="task-progress-item pointer" :class="{ active: taskInfo?.jdjkState, current: props.current == 5 }"
        @click="linkTo(4)">
        <loading-outlined class="icon-loading" v-if="stepLoadingStates[4]" />
        <check-circle-filled class="icon-check-circle" v-else-if="taskInfo?.jdjkState" />
        <span class="icon-uncheck-circle" v-else></span>
        进度监控
      </div>
      <span class="task-progress-arrow">→</span>
      <div class="task-progress-item pointer" :class="{ active: taskInfo?.ycclState, current: props.current == 6 }"
        @click="linkTo(5)">
        <loading-outlined class="icon-loading" v-if="stepLoadingStates[5]" />
        <check-circle-filled class="icon-check-circle" v-else-if="taskInfo?.ycclState" />
        <span class="icon-uncheck-circle" v-else></span>
        异常处理
      </div>
      <span class="task-progress-arrow">→</span>
      <div class="task-progress-item pointer" :class="{ active: taskInfo?.cjfbState, current: props.current == 7 }"
        @click="linkTo(6)">
        <loading-outlined class="icon-loading" v-if="stepLoadingStates[6]" />
        <check-circle-filled class="icon-check-circle" v-else-if="taskInfo?.cjfbState" />
        <span class="icon-uncheck-circle" v-else></span>
        成绩发布
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from "vue";
import { CheckCircleFilled, LoadingOutlined } from "@ant-design/icons-vue";
import { ITaskProgress } from "@/type/examManage";
import { useRouter, useRoute } from "vue-router";
import { request } from "@/services";
const emit = defineEmits(["update:taskName"]);
const router = useRouter();
const route = useRoute();
const props = defineProps({
  current: {
    type: Number,
    default: 1,
  },
  taskName: {
    type: String,
    default: "",
  },
});
const taskInfo = ref<ITaskProgress>();
const taskName = ref("");
const gradeCode = ref("");
const stepLoadingStates = ref<boolean[]>([false, false, false, false, false, false, false]);
const linkTo = (status: number) => {
  const path = ["TikaSetting", "MarkSetting", "TemplateMaking", "PaperScanContainer", "ProgressMonitoring", "ExceptionHandling", "ScoreRelease"];
  const routeMap: Record<number, string> = {
    0: "TikaSetting",
    1: "MarkSetting",
    2: "TemplateMaking",
    3: "PaperScanContainer",
    4: "ProgressMonitoring",
    5: "ExceptionHandling",
    6: "ScoreRelease"
  };
  router.push({
    name: routeMap[status],
    params: { taskId: taskInfo.value?.taskId, taskName: encodeURIComponent(taskName.value || '') },
    state: { ...history.state, subjectId: history.state.subjectId, createId: history.state.createId || taskInfo.value?.createId, gradeCode: gradeCode.value },
  });
};
const getTaskInfo = () => {
  request.get("/task/get-task-info", { params: { taskId: route.params.taskId.toString() } }).then((res) => {
    if (res.code === 200) {
      taskName.value = res.data.name;
      gradeCode.value = res.data.gradeCode;
    }
  });
};
// 防止重复调用标志
const isLoadingTaskProgress = ref(false);

const getTaskProgress = () => {
  // 防重复调用
  if (isLoadingTaskProgress.value) {
    return;
  }

  // 检查必需参数
  const taskId = route.params.taskId?.toString();
  if (!taskId) {
    return;
  }

  isLoadingTaskProgress.value = true;
  
  // 步骤映射：step索引映射到状态字段名
  const stepMapping = {
    0: 'tkState',
    1: 'yjState',
    2: 'mbzzState',
    3: 'djsmState',
    4: 'jdjkState',
    5: 'ycclState',
    6: 'cjfbState'
  };

  // 设置所有步骤为loading状态
  stepLoadingStates.value = [true, true, true, true, true, true, true];

  // 初始化taskInfo对象
  if (!taskInfo.value) {
    taskInfo.value = {} as ITaskProgress;
  }

  // 先异步调用 common/get-notice（不阻塞步骤状态请求）
  request.get("/common/get-notice")
    .then(() => {
      // common/get-notice 请求成功
    })
    .catch(() => {
      // common/get-notice 请求失败
    });

  // 创建7个步骤状态请求
  const stepRequests = [];
  for (let step = 0; step < 7; step++) {
    stepRequests.push(
      request.get("/task/get-task-step-state", { 
        params: { 
          taskId: taskId, 
          step: step 
        } 
      })
    );
  }
  
  // 执行步骤状态请求
  Promise.allSettled(stepRequests)
    .then((results) => {
      // 处理每个步骤状态请求结果
      results.forEach((result, index) => {
        const stepIndex = index; // 步骤索引（0-6）
        
        // 清除对应步骤的loading状态
        stepLoadingStates.value[stepIndex] = false;
        
        if (result.status === 'fulfilled' && result.value.code === 200) {
          // 请求成功，更新对应的状态字段
          const stateField = stepMapping[stepIndex as keyof typeof stepMapping];
          if (taskInfo.value && stateField) {
            (taskInfo.value as any)[stateField] = result.value.data;
          }
        }
      });
      
      // 发出更新事件
      emit("update:taskName", taskName.value);
      
    })
    .catch(() => {
      // 清除所有loading状态
      stepLoadingStates.value = [false, false, false, false, false, false, false];
    })
    .finally(() => {
      isLoadingTaskProgress.value = false;
    });
};
onMounted(() => {
  getTaskInfo();
  getTaskProgress();
});
</script>
